import {
    ImageWrapper,
    StyledHeaderIntroductionBlock,
    StyledIntroductionBlock,
    StyledIntroductionView,
    StyledIntroductionViewInnerBlock,
    StyledIntroViewAction,
    StyledIntroViewIcon,
    StyledIntroViewLink,
    StyledListIntroductionBlock,
} from "./styles";
import { AssetsService } from "app/services/AssetsService";
import type { FC } from "react";
import { IconButton } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import IntroductionViewListItem from "./IntroductionViewListItem";

type IntroViewProp = {
    onActionClick: () => void;
};
const IntroductionView: FC<IntroViewProp> = ({ onActionClick }) => {
    return (
        <StyledIntroductionView>
            <StyledIntroductionViewInnerBlock>
                <StyledIntroductionBlock>
                    <StyledHeaderIntroductionBlock>
                        {translate("si.intent.introduction.header")}
                    </StyledHeaderIntroductionBlock>
                    <StyledListIntroductionBlock>
                        <IntroductionViewListItem text={translate("si.intent.introduction.subItem1")} />
                        <IntroductionViewListItem text={translate("si.intent.introduction.subItem2")} />
                        <IntroductionViewListItem text={translate("si.intent.introduction.subItem3")} />
                    </StyledListIntroductionBlock>
                    <StyledIntroViewAction>
                        <IconButton
                            type="primary"
                            iconName="arrow-right"
                            placement={"right"}
                            onClick={onActionClick}
                        >
                            {translate("si.intent.introduction.set_topics.button")}
                        </IconButton>

                        <StyledIntroViewLink
                            href={"https://support.similarweb.com/hc/en-us/articles/14234221556509"}
                            target={"_blank"}
                        >
                            {translate("si.signals.traffic-changes.learnMore")}
                            <StyledIntroViewIcon
                                iconName="link-out"
                                size="xs"
                            />
                        </StyledIntroViewLink>
                    </StyledIntroViewAction>
                </StyledIntroductionBlock>
                <ImageWrapper>
                    <img
                        src={AssetsService.assetUrl("/images/intent/intent_upsell.svg")}
                        alt="New intent introduction window"
                    />
                </ImageWrapper>
            </StyledIntroductionViewInnerBlock>
        </StyledIntroductionView>
    );
};

export default IntroductionView;
